<script >
import { langTextMap, useI18n } from '../common/i18n';
import useStockQuote from '../composables/useStockQuote';
import useUserWch from '../composables/useUserWch';
import useUpDownType from '../composables/useUpDownType';
import { getSchemeLink } from '../common/scheme';
import { THEME } from '../common/enum';
import { computed } from 'vue-demi';
import stockOp from './stock-op.vue';
const __sfc_main = {};
__sfc_main.props = {
  stockId: Number,
  upDownType: Number,
  language: String,
  increaseType: String,
  tagList: Array,
  theme: String,
  textColor: String,
  showCollect: Boolean,
  showTrade: Boolean,
  clickToStockDetail: Boolean,
  tradeButtonText: String,
  stockCustomName: String
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    loaded,
    stockQuote
  } = useStockQuote(props);
  const {
    selectedStatus,
    setSelectStatus
  } = useUserWch(props.stockId, props.language);
  const {
    upDownTypeCls
  } = useUpDownType(props);

  // css变量 控制文本颜色
  const cssVar = computed(() => {
    //只有自定义主题才设置文本颜色
    if (props.theme === THEME.CUSTOM) {
      return {
        '--card-text-color': props.textColor
      };
    }
    return {};
  });
  const themeClass = computed(() => {
    const classList = [];
    if (props.theme === THEME.LIGHT) {
      classList.push('light');
    } else if (props.theme === THEME.DARK) {
      classList.push('dark');
    }
    if (!loaded) {
      classList.push('loading');
    }
    return classList;
  });
  const $t = computed(() => {
    return useI18n(langTextMap, props.language);
  });
  const stockQuoteName = computed(() => {
    if (props.stockCustomName) {
      return props.stockCustomName;
    }
    // eslint-disable-next-line max-len
    const nameStr = stockQuote?.value?.allName?.strContext?.find?.(strItem => strItem.languageId === Number(props.language));
    return nameStr?.context || stockQuote.value.name;
  });

  // 点击跳转
  const {
    useBehaviour
  } = require('@fegobull/webapi').use;
  const {
    runBehaviour
  } = useBehaviour();
  const onClick = $event => {
    if (!props.clickToStockDetail) {
      return;
    }
    const link = getSchemeLink(props.stockId);
    runBehaviour(null, {
      type: 'jump',
      value: link
    }, $event);
  };
  return {
    props,
    stockQuote,
    selectedStatus,
    setSelectStatus,
    upDownTypeCls,
    cssVar,
    themeClass,
    $t,
    stockQuoteName,
    onClick
  };
};
__sfc_main.components = Object.assign({
  stockOp
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div class="quotes-card-v3" :class="themeClass" :style="cssVar" @click="onClick">
        <div class="header-block">
            <div class="stock-info">
                <p class="stock-info__name over-text">{{ stockQuoteName }}</p>
            </div>
            <p class="tag-ls">
                <span class="tag-ls__item" v-for="tag in tagList" :key="tag">
                    {{ tag.tagText }}
                </span>
            </p>
        </div>
        <div class="content-block">
            <div class="stock-quote">
                <p
                    :class="[
                        'stock-quote__increase-rate',
                        upDownTypeCls,
                        {
                            up: stockQuote.rate > 0,
                            down: stockQuote.rate < 0
                        }
                    ]"
                >
                    {{ stockQuote.rateStr }}
                </p>
                <p class="stock-quote__increase-type">{{ $t(increaseType) }}</p>
            </div>
            <stock-op
                :selected="selectedStatus"
                :actionFn="setSelectStatus"
                :showCollect="props.showCollect"
                :showTrade="props.showTrade"
                :tradeButtonText="props.tradeButtonText"
                :theme="props.theme"
                :textColor="props.textColor"
            />
        </div>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
